import React from "react";

const ProductContext = React.createContext({
  list: { original: [] as any, filter: [] as any },
  originalList: (item: any) => {},
  filterList: (item: any) => {},
});

export default ProductContext;
